export const baseUrl = "/api/0";
